import _objectSpread from "/data/jenkins/workspace/wyt-admin/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, unref as _unref, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, mergeProps as _mergeProps } from "vue";

const _hoisted_1 = /*#__PURE__*/_createTextVNode("查询");

const _hoisted_2 = /*#__PURE__*/_createTextVNode("重置");

const _hoisted_3 = /*#__PURE__*/_createTextVNode("新增");

const _hoisted_4 = {
  class: "table-operation"
};

const _hoisted_5 = /*#__PURE__*/_createTextVNode("查看");

const _hoisted_6 = /*#__PURE__*/_createTextVNode("编辑");

const _hoisted_7 = /*#__PURE__*/_createTextVNode("删除");

const _hoisted_8 = /*#__PURE__*/_createTextVNode("提前结束");

const _hoisted_9 = /*#__PURE__*/_createTextVNode(" 发放记录 ");

import { ref, reactive } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { getVexTableProps } from '@/config';
import { getRedPacketList, removeActivity, endActivity } from '@/request';
import { ElMessage, ElMessageBox } from 'element-plus';
import RecordModal from './components/record-modal.vue';
export default {
  name: 'index',

  setup(__props) {
    const route = useRoute();
    const router = useRouter();
    const activityStatus = [{
      label: '未开始',
      value: 1
    }, {
      label: '进行中',
      value: 2
    }, {
      label: '已结束',
      value: 3
    }];
    const form = reactive({
      activityName: '',
      activityStatus: '',
      activityPublisher: ''
    });
    const table = ref();
    const tableOptions = getVexTableProps({
      loading: false,
      toolbarConfig: {
        slots: {
          buttons: 'tools'
        }
      },
      columns: [{
        title: '活动ID',
        field: 'activityId'
      }, {
        title: '活动名称',
        field: 'activityName'
      }, {
        title: '活动状态',
        field: 'activityStatusName',
        width: '120px'
      }, {
        title: '活动类型',
        field: 'activityTypName',
        width: '140px'
      }, {
        title: '活动发起方',
        field: 'activityPublisher',
        showOverflow: 'tooltip'
      }, {
        title: '活动时间',
        field: 'activityStartTime',
        slots: {
          default: 'time'
        }
      }, {
        title: '操作',
        slots: {
          default: 'operation'
        },
        align: 'left',
        headerAlign: 'center',
        width: '240px'
      }],
      proxyConfig: {
        ajax: {
          query: ({
            page
          }) => new Promise(res => {
            getRedPacketList(_objectSpread({
              page: page.currentPage,
              pageSize: page.pageSize,
              activityType: 'HB'
            }, form)).then(data => {
              res({
                total: data.data.totalSize,
                result: data.data.activityList
              });
            });
          })
        }
      }
    });

    function resetHandle() {
      Object.keys(form).forEach(key => {
        form[key] = '';
      });
      table.value.commitProxy('reload');
    } // 删除活动


    function reomveHandle(activityId) {
      ElMessageBox.confirm('确认删除该活动吗？', '提示').then(() => {
        removeActivity({
          activityId
        }).then(res => {
          let {
            success,
            msg
          } = res;

          if (success) {
            ElMessage.success(msg);
            table.value.commitProxy('query');
            return true;
          }

          ElMessage.error(msg);
          return false;
        });
      });
    } // 提前结束活动


    function endHandle(activityId) {
      ElMessageBox.confirm('确认提前结束该活动吗？', '提示').then(() => {
        endActivity({
          activityId
        }).then(res => {
          let {
            success,
            msg
          } = res;

          if (success) {
            ElMessage.success(msg);
            table.value.commitProxy('query');
            return true;
          }

          ElMessage.error(msg);
          return false;
        });
      });
    }

    const recordModal = reactive({
      visible: false,
      activityId: undefined
    });

    function checkRecordHandle(activityId) {
      recordModal.visible = true;
      recordModal.activityId = activityId;
    }

    function activityActionHandle(pageType, activityId) {
      router.push({
        name: 'ActivityUpdate',
        query: {
          from: route.name,
          pageType,
          activityId
        }
      });
    }

    function setRecordStyle(status) {
      if (status === 3) {
        return {
          marginLeft: '10px'
        };
      }
    }

    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");

      const _component_el_form_item = _resolveComponent("el-form-item");

      const _component_el_option = _resolveComponent("el-option");

      const _component_el_select = _resolveComponent("el-select");

      const _component_el_button = _resolveComponent("el-button");

      const _component_el_form = _resolveComponent("el-form");

      const _component_vxe_grid = _resolveComponent("vxe-grid");

      return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_el_form, {
        inline: true
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, {
          label: "活动名称"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: form.activityName,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => form.activityName = $event),
            placeholder: "请输入活动名称"
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "活动状态"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_select, {
            modelValue: form.activityStatus,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => form.activityStatus = $event),
            placeholder: "全部",
            clearable: ""
          }, {
            default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(activityStatus, item => {
              return _createVNode(_component_el_option, {
                value: item.value,
                label: item.label,
                key: item.value
              }, null, 8, ["value", "label"]);
            }), 64))]),
            _: 1
          }, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "活动发起方"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: form.activityPublisher,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => form.activityPublisher = $event),
            placeholder: "请输入活动发起方"
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, null, {
          default: _withCtx(() => [_createVNode(_component_el_button, {
            type: "primary",
            icon: "Search",
            onClick: _cache[3] || (_cache[3] = $event => table.value.commitProxy('reload'))
          }, {
            default: _withCtx(() => [_hoisted_1]),
            _: 1
          }), _createVNode(_component_el_button, {
            type: "primary",
            icon: "Refresh",
            onClick: resetHandle
          }, {
            default: _withCtx(() => [_hoisted_2]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_vxe_grid, _mergeProps({
        ref_key: "table",
        ref: table
      }, _unref(tableOptions)), {
        tools: _withCtx(() => [_createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[4] || (_cache[4] = $event => activityActionHandle('create'))
        }, {
          default: _withCtx(() => [_hoisted_3]),
          _: 1
        })]),
        operation: _withCtx(({
          row
        }) => [_createElementVNode("div", _hoisted_4, [_createVNode(_component_el_button, {
          type: "primary",
          onClick: $event => activityActionHandle('view', row.activityId)
        }, {
          default: _withCtx(() => [_hoisted_5]),
          _: 2
        }, 1032, ["onClick"]), row.activityStatus === 1 ? (_openBlock(), _createBlock(_component_el_button, {
          key: 0,
          type: "primary",
          onClick: $event => activityActionHandle('update', row.activityId)
        }, {
          default: _withCtx(() => [_hoisted_6]),
          _: 2
        }, 1032, ["onClick"])) : _createCommentVNode("", true), row.activityStatus === 1 ? (_openBlock(), _createBlock(_component_el_button, {
          key: 1,
          type: "danger",
          style: {
            "margin-left": "10px"
          },
          onClick: $event => reomveHandle(row.activityId)
        }, {
          default: _withCtx(() => [_hoisted_7]),
          _: 2
        }, 1032, ["onClick"])) : _createCommentVNode("", true), row.activityStatus === 2 ? (_openBlock(), _createBlock(_component_el_button, {
          key: 2,
          type: "danger",
          style: {
            "margin-right": "10px"
          },
          onClick: $event => endHandle(row.activityId)
        }, {
          default: _withCtx(() => [_hoisted_8]),
          _: 2
        }, 1032, ["onClick"])) : _createCommentVNode("", true), row.activityStatus === 2 || row.activityStatus === 3 ? (_openBlock(), _createBlock(_component_el_button, {
          key: 3,
          type: "success",
          style: _normalizeStyle(setRecordStyle(row.activityStatus)),
          onClick: $event => checkRecordHandle(row.activityId)
        }, {
          default: _withCtx(() => [_hoisted_9]),
          _: 2
        }, 1032, ["style", "onClick"])) : _createCommentVNode("", true)])]),
        time: _withCtx(({
          row
        }) => [_createElementVNode("div", null, _toDisplayString(row.activityStartTime) + " - " + _toDisplayString(row.activityEndTime), 1)]),
        _: 1
      }, 16), _createVNode(RecordModal, {
        modelValue: recordModal.visible,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => recordModal.visible = $event),
        activityId: recordModal.activityId
      }, null, 8, ["modelValue", "activityId"])]);
    };
  }

};